import React from "react";
import {useEffect, useState} from "react";

function MUKHVAS_DANI() {
    const [data, setData] = useState([]);
    const [isLoading, setisLoading] = useState(true);
    // setLoding(false);
    useEffect(() => {
        fetch("https://dharatiengineering.in/ad_dharati/Api/Product/Images/MUKHVAS-DANI", setisLoading(true)).then((res) => {
            return res.json();
        }).then((res) => {
            setData(res.data);
            console.log(data);
            setisLoading(false);
        });
    }, []);

    const MukhvasDaniDetails = data.map((mukhvasdani) => {
        return (
            <>
                <div className="portfolio-item filter-web col-lg-3 col-sm-6">
                    <div className="portfolio-wrap">
                        <img src={
                                "https://dharatiengineering.in/ad_dharati/Images/product/"+mukhvasdani.Path
                            }
                            className="img-fluid shadow-4"
                            alt="Dharti Engineering MukhvasDani Image"/>
                    </div>
                </div>
            </>
        );
    });

    return (
        <>
            <section id="portfolio" className="portfolio">
                <div className="container">
                    <div>
                        <hr/>
                        <h2 className="text-center"style={{ color : '#AB7442'}}>MUKHVAS DANI</h2>
                        <hr/>
                    </div>
                    <div className="row portfolio-container animate__animated animate__fadeInDown">
                        {MukhvasDaniDetails}
                        </div>
                </div>
            </section>
        </>
    );
}

export default MUKHVAS_DANI;
